import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { companyInfo } from '../mock';
import { toast } from 'sonner';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      const response = await axios.post(`${API}/contact`, formData);
      
      if (response.data.success) {
        toast.success(response.data.message, {
          description: 'We appreciate your interest in Naru Tofu.',
          duration: 5000,
        });
        setFormData({ name: '', email: '', phone: '', message: '' });
      }
    } catch (error) {
      console.error('Contact form error:', error);
      toast.error('Failed to submit your message', {
        description: 'Please try again or contact us directly at admin@narutofu.com',
        duration: 5000,
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>Contact Naru Tofu | Get in Touch</title>
        <meta name="description" content="Contact Naru Tofu Organics - reach us for orders, partnerships, or inquiries. Phone: +91 85948 35784. Email: admin@narutofu.com" />
        <link rel="canonical" href="https://narutofu.com/contact" />
      </Helmet>
      <section id="contact" className="contact-section section-padding" style={{ background: 'var(--bg-secondary)', minHeight: '100vh' }}>
      <div className="container">
        <h1 className="hero-large" style={{ textAlign: 'center', marginBottom: '60px' }}>Get in Touch</h1>
        
        <div className="grid-two-column">
          <div>
            <h2 className="hero-medium" style={{ marginBottom: '24px' }}>Contact Us</h2>
            <p className="body-large" style={{ marginBottom: '32px', color: 'var(--text-secondary)' }}>
              Have questions about our products or want to stock Naru Tofu? We'd love to hear from you.
            </p>
            
            <div className="contact-info">
              <div style={{ marginBottom: '24px' }}>
                <h4 className="heading-3" style={{ marginBottom: '8px' }}>Email</h4>
                <p className="body-regular">{companyInfo.email}</p>
              </div>
              
              <div style={{ marginBottom: '24px' }}>
                <h4 className="heading-3" style={{ marginBottom: '8px' }}>Phone</h4>
                <p className="body-regular">+91 85948 35784</p>
                <p className="body-regular">+91 93390 29313</p>
              </div>
              
              <div style={{ marginBottom: '24px' }}>
                <h4 className="heading-3" style={{ marginBottom: '8px' }}>Manufacturing Unit</h4>
                <p className="body-regular">{companyInfo.manufacturing.address}</p>
                <p className="body-small" style={{ marginTop: '8px', color: 'var(--text-secondary)' }}>FSSAI: {companyInfo.manufacturing.fssai}</p>
              </div>
            </div>
          </div>
          
          <div>
            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-group">
                <label htmlFor="name" className="body-regular">Name</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                  className="form-input"
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="email" className="body-regular">Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                  className="form-input"
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="phone" className="body-regular">Phone</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleInputChange}
                  className="form-input"
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="message" className="body-regular">Message</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleInputChange}
                  required
                  rows="5"
                  className="form-input"
                />
              </div>
              
              <button 
                type="submit" 
                className="btn-primary" 
                style={{ width: '100%' }}
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Sending...' : 'Send message'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
    </>
  );
};

export default ContactPage;